import { type CurrencyIconsCodes } from '@capsicum/common';
import { cloneElement } from 'react';

import { BrlIcon } from '../../ui/icons/Brl';
import { ChilizChainCircleIcon } from '../../ui/icons/ChilizChainCircle';
import { EurIcon } from '../../ui/icons/Eur';
import { GbpIcon } from '../../ui/icons/Gbp';
import { KrwIcon } from '../../ui/icons/Krw';
import { ProfileIcon } from '../../ui/icons/Profile';
import { TryIcon } from '../../ui/icons/Try';
import { UsdIcon } from '../../ui/icons/Usd';

export type IconSize = 'big' | 'large' | 'medium' | 'small';

export const sizeIcons: Record<IconSize, number> = {
	big: 60,
	large: 72,
	medium: 48,
	small: 24
};

export const currencyIcons: Record<CurrencyIconsCodes, JSX.Element> = {
	BRL: <BrlIcon />,
	CHZ: <ChilizChainCircleIcon />,
	EUR: <EurIcon />,
	GBP: <GbpIcon />,
	KRW: <KrwIcon />,
	TRY: <TryIcon />,
	USD: <UsdIcon />
};

export const useCurrencyIcon = () => {
	const getCurrencyIcon = (currencyShortCode?: string, size: IconSize = 'small') => {
		const IconComponent = currencyIcons[currencyShortCode as CurrencyIconsCodes];

		const numericSize = sizeIcons[size];

		if (!IconComponent) return <ProfileIcon height={numericSize} width={numericSize} />;

		return cloneElement(IconComponent, { height: numericSize, width: numericSize });
	};

	return { getCurrencyIcon };
};
